import { gql } from '@apollo/client'

const EDIT_PLAN_PAGE_QUERY = gql`
  query EditPlanPageQuery {
    user {
      id
      preferredLanguage
      shippingCountryCode
      dogs {
        id
        name
        gender
        planPortionInGrams
      }
      subscription {
        id
        status
        meal {
          quantity
          flavour {
            id
            slug
            thumbnail {
              src
            }
          }
        }
        previewUncreatedFutureBox {
          isoDeliveryDate
          plan {
            pricePerDay
            id
          }
        }
      }
    }
  }
`

export { EDIT_PLAN_PAGE_QUERY }
